import React, { useState } from "react";
import { Table, Button, Badge } from "react-bootstrap";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import '../../../assets/css/seller/SellerCancelledOrders/sellerCancelledOrders.css';


const SellerOngoingOrders = () => {
  const [orders, setOrders] = useState([
    {
      id: "ORD-001",
      products: [
        { name: "Wireless Mouse", price: 29.99 },
        { name: "USB-C Cable", price: 12.99 },
      ],
      customer: {
        name: "John Smith",
        phone: "+1 (555) 123-4567",
        address: "123 Main Street, New York, NY 10001",
      },
      status: "pending",
    },
    {
      id: "ORD-001",
      products: [
        { name: "Wireless Mouse", price: 29.99 },
        { name: "USB-C Cable", price: 12.99 },
      ],
      customer: {
        name: "John Smith",
        phone: "+1 (555) 123-4567",
        address: "123 Main Street, New York, NY 10001",
      },
      status: "pending",
    },
    {
      id: "ORD-001",
      products: [
        { name: "Wireless Mouse", price: 29.99 },
        { name: "USB-C Cable", price: 12.99 },
      ],
      customer: {
        name: "John Smith",
        phone: "+1 (555) 123-4567",
        address: "123 Main Street, New York, NY 10001",
      },
      status: "pending",
    },
    {
      id: "ORD-001",
      products: [
        { name: "Wireless Mouse", price: 29.99 },
        { name: "USB-C Cable", price: 12.99 },
      ],
      customer: {
        name: "John Smith",
        phone: "+1 (555) 123-4567",
        address: "123 Main Street, New York, NY 10001",
      },
      status: "pending",
    },
  ]);

  const calculateTotal = (products) => {
    return products.reduce((sum, product) => sum + product.price, 0).toFixed(2);
  };
  return (
    <SellerMasterLayout>
      <table className="seller-table">
        <thead className="seller-thead">
          <tr className="seller-tr-head">
            <th className="seller-th">Order ID</th>
            <th className="seller-th">Order Details</th>
            <th className="seller-th">Customer Name</th>
            <th className="seller-th">Phone</th>
            <th className="seller-th">Address</th>
            <th className="seller-th">Status</th>
            <th className="seller-th">Actions</th>
          </tr>
        </thead>
        <tbody className="seller-tbody">
          {orders.map((order) => (
            <tr
              key={order.id}
              className={`seller-tr seller-status-${order.status}`}
            >
              <td className="seller-td seller-order-id">
                <div className="seller-id-badge">{order.id}</div>
              </td>
              <td className="seller-td seller-order-details">
                <div className="seller-products-container">
                  {order.products.map((product, index) => (
                    <div key={index} className="seller-product-item">
                      <div className="seller-product-info">
                        <span className="seller-product-name">
                          {product.name}
                        </span>
                        <span className="seller-product-price">
                          ${product.price.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="seller-total-box">
                    <span className="seller-total-label">Total:</span>
                    <span className="seller-total-amount">
                      ${calculateTotal(order.products)}
                    </span>
                  </div>
                </div>
              </td>
              <td className="seller-td seller-customer-name">
                <div className="seller-info-group">
                  <svg
                    className="seller-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <span>{order.customer.name}</span>
                </div>
              </td>
              <td className="seller-td seller-customer-phone">
                <div className="seller-info-group">
                  <svg
                    className="seller-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <span>{order.customer.phone}</span>
                </div>
              </td>
              <td className="seller-td seller-customer-address">
                <div className="seller-info-group">
                  <svg
                    className="seller-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span>{order.customer.address}</span>
                </div>
              </td>
              <td className="seller-td seller-status-cell">
                {order.status === "completed" && (
                  <span className="seller-badge seller-badge-success">
                    <svg
                      className="seller-badge-icon"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Completed
                  </span>
                )}
                {order.status === "cancelled" && (
                  <span className="seller-badge seller-badge-danger">
                    <svg
                      className="seller-badge-icon"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="15" y1="9" x2="9" y2="15" />
                      <line x1="9" y1="9" x2="15" y2="15" />
                    </svg>
                    Cancelled
                  </span>
                )}
                {order.status === "pending" && (
                  <span className="seller-badge seller-badge-warning">
                    <svg
                      className="seller-badge-icon"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    Pending
                  </span>
                )}
              </td>
              <td className="seller-td seller-actions-cell">
                <div className="seller-button-group">
                  <button
                    className="seller-btn seller-btn-complete"
                    // onClick={() => handleComplete(order.id)}
                    disabled={order.status !== "pending"}
                  >
                    <svg
                      className="seller-btn-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Complete
                  </button>
                  <button
                    className="seller-btn seller-btn-cancel"
                    // onClick={() => handleCancel(order.id)}
                    disabled={order.status !== "pending"}
                  >
                    <svg
                      className="seller-btn-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* <div className="seller-container">
        <div className="seller-table-wrapper">
          
        </div>
      </div> */}
    </SellerMasterLayout>
  );
};

export default SellerOngoingOrders;